import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  FaReact, FaPython, FaGitAlt, FaCss3Alt,
  FaJs, FaDatabase, FaFileExcel, FaFlask, FaNodeJs,
  FaGithub, FaNpm
} from 'react-icons/fa';
import { SiMongodb, SiVite, SiFirebase } from 'react-icons/si';
import { motion } from 'framer-motion';

const Skills = () => {
  const { t } = useTranslation();
  const skills = [
    { name: 'CSS3', icon: <FaCss3Alt size={60} /> },
    { name: 'JavaScript', icon: <FaJs size={60} /> },
    { name: 'React', icon: <FaReact size={60} /> },
    { name: 'Node.js', icon: <FaNodeJs size={60} /> },
    { name: 'Git', icon: <FaGitAlt size={60} /> },
    { name: 'GitHub', icon: <FaGithub size={60} /> },
    { name: 'Python', icon: <FaPython size={60} /> },
    { name: 'Flask', icon: <FaFlask size={60} /> },
    { name: 'MongoDB', icon: <SiMongodb size={60} /> },
    { name: 'SQL', icon: <FaDatabase size={60} /> },
    { name: 'Excel', icon: <FaFileExcel size={60} /> },
    { name: 'NPM', icon: <FaNpm size={60} /> },
    { name: 'Vite', icon: <SiVite size={60} /> },
    { name: 'Firebase', icon: <SiFirebase size={60} /> },
  ];

  const containerVariants = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: {
        staggerChildren: 0.08,
        delayChildren: 0.1
      }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    show: { opacity: 1, y: 0, transition: { duration: 0.4 } }
  };

  return (
    <section
      id="skills"
      style={{
        background: 'linear-gradient(135deg, #f5f5f5 0%, #e8e8e8 100%)',
        padding: '80px 20px',
        position: 'relative'
      }}
    >
      <div className="container" style={{ maxWidth: '1200px', margin: '0 auto' }}>
        {/* Header con barra superior */}
        <motion.div
          initial={{ opacity: 0, y: -20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          {/* Barra superior */}
          <div
            style={{
              background: '#cc0033',
              color: 'white',
              padding: '8px 20px',
              fontSize: '0.85rem',
              fontWeight: '600',
              letterSpacing: '2px',
              textTransform: 'uppercase',
              marginBottom: '30px',
              display: 'inline-block'
            }}
          >
            {t('skills.tag')}
          </div>

          {/* Título principal */}
          <h2
            style={{
              fontSize: '2.5rem',
              fontWeight: '700',
              color: '#1a1a1a',
              marginBottom: '20px',
              fontFamily: 'Montserrat, sans-serif'
            }}
          >
            {t('skills.title')}
          </h2>

          {/* Subtítulo */}
          <p
            style={{
              fontSize: '1.05rem',
              color: '#555',
              marginBottom: '50px',
              maxWidth: '800px'
            }}
          >
            {t('skills.subtitle')}
          </p>
        </motion.div>

        {/* Grid de habilidades */}
        <motion.div
          variants={containerVariants}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, amount: 0.2 }}
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(140px, 1fr))',
            gap: '30px',
            marginBottom: '60px'
          }}
        >
          {skills.map((skill, index) => (
            <motion.div
              key={index}
              variants={itemVariants}
              whileHover={{
                y: -8,
                transition: { duration: 0.2 }
              }}
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: '15px',
                cursor: 'default'
              }}
            >
              {/* Icono */}
              <div
                style={{
                  color: '#1a1a1a',
                  transition: 'all 0.3s ease',
                  filter: 'drop-shadow(0 4px 8px rgba(0, 0, 0, 0.1))'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.color = '#cc0033';
                  e.currentTarget.style.transform = 'scale(1.1)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.color = '#1a1a1a';
                  e.currentTarget.style.transform = 'scale(1)';
                }}
              >
                {skill.icon}
              </div>

              {/* Nombre */}
              <span
                style={{
                  fontSize: '0.9rem',
                  fontWeight: '500',
                  color: '#333',
                  textAlign: 'center'
                }}
              >
                {skill.name}
              </span>
            </motion.div>
          ))}
        </motion.div>

      </div>
    </section>
  );
};

export default Skills;